import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import {Grid , Box , Divider, TextField} from '@material-ui/core';
import UserCard from './UserCard'
import ReviewCard from './ReviewCard'
const useStyles = makeStyles({

   greytypo: {
      color: '#888888' ,
      fontSize :'12px'
    },
    
  });

  const DataCard = ({record }) => {

    const classes = useStyles();
   
    return (
    <Box border={1}>
        <Grid container outlined spacing={1} >
            <UserCard record = {record} />
            
            {record.review.map((element) => (
                <ReviewCard record={element} />
            ))}
        </Grid>
    </Box>
    );
}

export default DataCard;